import { Component, OnInit } from '@angular/core';
import { Router ,ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.css']
})
export class PaymentSuccessComponent implements OnInit {

  transactionID:string;
  amount;
  invoiceNo:string;
  notSupportedSize : boolean;
  rightPanel:boolean;

  constructor(private router: Router , private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {

    this.activatedRoute.queryParams.subscribe(queryParams => {
        this.transactionID = queryParams['transactionID'];
        this.amount = queryParams['amount'];
      });

    // if( this.route.queryParams['_value']['transactionID'])
    // {
    //   this.transactionID = this.route.queryParams['_value']['transactionID'];
    //   this.amount = this.route.queryParams['_value']['amount'];
    //   // this.invoiceNo = this.route.queryParams['_value']['invoiceNo'];
    // }
  }

  routeToHome(){
    this.router.navigateByUrl('/questionnaires') ;
  }
}



// WEBPACK FOOTER //
// ./src/app/payment-success/payment-success.component.ts